/* 🤖 this file was generated by svg-to-ts */
export const matIconCalendarViewDay: {
  name: 'calendar-view-day';
  data: string;
} = {
  name: 'calendar-view-day',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z"/></svg>`
};
